.appShell {
    container-name: app-container;
    container-type: size;
}

.appShell :global(.mantine-AppShell-navbar) {
    border-inline-end: none;
}

.main {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: stretch;
    position: relative;
    height: 100cqh;
    width: 100%;
    overflow-x: clip;
    overflow-y: hidden;
}

.mainContent {
    flex: 1;
    min-height: 0;
    width: 100%;
    overflow-y: auto;
    scrollbar-gutter: stable;
    display: flex;
    flex-direction: column;
    align-items: center;
}
